export const ACTION_LOADING_MESSAGE_KEY = 'commerceContractLib.actions.loading.tooltip';
const CommonValidationErrors = Object.freeze({
  UNAUTHORIZED: 'UNAUTHORIZED',
  JITA_USER: 'JITA_USER'
});
const APIValidationErrors = Object.freeze({
  CONTRACT_NOT_ACTIVE: 'CONTRACT_NOT_ACTIVE',
  CONTRACT_NOT_BILLING_ENABLED: 'CONTRACT_NOT_BILLING_ENABLED',
  COLLECTION_PROCESS_MUST_BE_AUTOMATIC: 'COLLECTION_PROCESS_MUST_BE_AUTOMATIC',
  NO_PAYMENT_METHOD_SET: 'NO_PAYMENT_METHOD_SET',
  CONTRACT_TERMINATION_ALREADY_SCHEDULED: 'CONTRACT_TERMINATION_ALREADY_SCHEDULED',
  CONTRACT_TERMINATION_NOT_SCHEDULED: 'CONTRACT_TERMINATION_NOT_SCHEDULED',
  CANNOT_TERMINATE_WITH_PENDING_CHANGE_QUOTE: 'CANNOT_TERMINATE_WITH_PENDING_CHANGE_QUOTE',
  CANNOT_TERMINATE_WITH_PENDING_RENEWAL_QUOTE: 'CANNOT_TERMINATE_WITH_PENDING_RENEWAL_QUOTE'
});
export const ActionValidationError = Object.freeze(Object.assign({}, CommonValidationErrors, APIValidationErrors, {
  UNAVAILABLE: 'UNAVAILABLE',
  LOADING: 'LOADING'
}));